import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { useSearchQueryStore } from "@/store/SearchQueryStore";
import { useUrlStore } from "@/store/SerpPage/UrlStore";
import { usePopupStore } from "@/store/AutocompletePopup/PopupStore";
import { useMobileViewStore } from "@/store/MobileViewStore";
import { storeToRefs } from "pinia";
import { inject, onUnmounted, ref, watch, computed } from "vue";
import { SmartSearchTranslationsInterface } from "@/core/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'MoreResultsButton',
  setup(__props) {

const SmartSearchConfig = inject("SmartSearchConfig").value;
const urlStore = useUrlStore();
const popupStore = usePopupStore();
const mobileViewStore = useMobileViewStore();

const searchQueryStore = useSearchQueryStore();
const { getSearchQuery } = storeToRefs(searchQueryStore);
const { hasAnyResults, showAutocompletePopup, showResults, loading } = storeToRefs(popupStore);
const { isMobileView } = storeToRefs(mobileViewStore);
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>("SmartSearchTranslations")!;
const stickyRef = ref<HTMLElement | null>(null);
let unregisterStickySafe: (() => void) | null = null;

watch(stickyRef, (element) => {
  unregisterStickySafe?.();
  if (element) {
    unregisterStickySafe = popupStore.registerSafeElement(element);
  }
});

onUnmounted(() => {
  unregisterStickySafe?.();
});

const currentQuery = computed(() => (getSearchQuery.value || "").trim());

const showButton = computed(() =>
    showResults.value &&
    !loading.value &&
    hasAnyResults.value &&
    currentQuery.value.length >= 3
);

const handleSeeMoreClick = () => {
  const rawQuery = (currentQuery.value || popupStore.lastQuery || "").trim();
  if (!rawQuery) return;

  urlStore.goToSerpPage(
    SmartSearchConfig.appConfiguration.redirectionUrl,
    rawQuery
  );
};

return (_ctx: any,_cache: any) => {
  return (_unref(isMobileView))
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [
        (_unref(showAutocompletePopup) && showButton.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "stickyRef",
              ref: stickyRef,
              id: "more-results-sticky",
              class: "more-results__container q-d-grid q-gap-2 q-col-12 q-mt-2 q-mx-auto"
            }, [
              (showButton.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "q-btn q-btn-danger more-results__link",
                    tabindex: "-1",
                    role: "button",
                    onClick: _withModifiers(handleSeeMoreClick, ["prevent"])
                  }, [
                    _createTextVNode(_toDisplayString(_unref(SmartSearchTranslations).autocomplete.seeMore) + " ", 1),
                    _withDirectives(_createElementVNode("span", null, " (" + _toDisplayString(_unref(popupStore).getTotalProducts) + ")", 513), [
                      [_vShow, _unref(popupStore).getTotalProducts]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 512))
          : _createCommentVNode("", true)
      ]))
    : _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 1,
        ref_key: "stickyRef",
        ref: stickyRef,
        id: "more-results-sticky",
        class: "more-results__container q-d-grid q-gap-2 q-col-12 q-mt-2 q-mx-auto"
      }, [
        (showButton.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "q-btn q-btn-danger more-results__link",
              tabindex: "-1",
              role: "button",
              onClick: _withModifiers(handleSeeMoreClick, ["prevent"])
            }, [
              _createTextVNode(_toDisplayString(_unref(SmartSearchTranslations).autocomplete.seeMore) + " ", 1),
              _withDirectives(_createElementVNode("span", null, " (" + _toDisplayString(_unref(popupStore).getTotalProducts) + ")", 513), [
                [_vShow, _unref(popupStore).getTotalProducts]
              ])
            ]))
          : _createCommentVNode("", true)
      ], 512)), [
        [_vShow, showButton.value]
      ])
}
}

})